import { defineStyleConfig, ThemeComponents } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

import { AlertTheme } from "@/theme/Alert.theme";
import { AvatarTheme } from "@/theme/Avatar.theme";
import { ButtonTheme } from "@/theme/Button.theme";
import { CardTheme } from "@/theme/Card.theme";
import { CheckboxTheme } from "@/theme/Checkbox.theme";
import { textLink } from "@/theme/helpers";
import { IconTheme } from "@/theme/Icon.theme";
import { InputTheme } from "@/theme/Input.theme";
import { MenuTheme } from "@/theme/Menu.theme";
import { ModalTheme } from "@/theme/Modal.theme";
import { NumberInputTheme } from "@/theme/NumberInput.theme";
import { PopoverTheme } from "@/theme/Popover.theme";
import { ProgressTheme } from "@/theme/Progress.theme";
import { RadioTheme } from "@/theme/Radio.theme";
import { SwitchTheme } from "@/theme/Switch.theme";
import { TableTheme } from "@/theme/Table.theme";
import { TabsTheme } from "@/theme/Tabs.theme";
import { TagTheme } from "@/theme/Tag.theme";
import { TextareaTheme } from "@/theme/Textarea.theme";

// form labels should be bold by default,
// fix problem with highlight when hovering between field and label
const FormLabel = defineStyleConfig({
  baseStyle: (props) => ({
    fontWeight: "medium",
    color: mode("gray.900", "gray.50")(props),
    mb: 0,
    pb: 2,
  }),
});

const Tooltip = defineStyleConfig({
  baseStyle: {
    borderRadius: "md",
    px: 2,
    py: 1,
  },
});

const Badge = defineStyleConfig({
  baseStyle: {
    textTransform: "none",
    fontWeight: "medium",
    borderRadius: "full",
  },
  sizes: {
    xs: {
      px: 1.5,
      py: "1px",
      fontSize: "xs",
    },
    sm: {
      px: 1.5,
      py: 0.5,
      fontSize: "xs",
    },
    md: {
      px: 2,
      py: 1,
      fontSize: "sm",
    },
  },
  defaultProps: {
    size: "sm",
  },
});

const Heading = defineStyleConfig({
  baseStyle: {
    fontWeight: "semibold",
  },
});

const Link = defineStyleConfig({
  variants: {
    default: textLink,
    unstyled: {
      textDecoration: "none",
      _hover: {
        textDecoration: "none",
      },
    },
  },
  defaultProps: {
    variant: "default",
  },
});

const Text = defineStyleConfig({
  variants: {
    veryDimmed: {
      color: "veryDimmed",
    },
    dimmed: {
      color: "dimmed",
    },
  },
});

const Divider = defineStyleConfig({
  baseStyle: {
    opacity: 1,
    borderColor: "appBorder",
  },
});

const Spinner = defineStyleConfig({
  variants: {
    subtle: {
      color: "dimmed",
    },
  },
  defaultProps: {
    size: "sm",
  },
});

const components: ThemeComponents = {
  FormLabel,
  Tooltip,
  Badge,
  Heading,
  Link,
  Text,
  Divider,
  Spinner,
  Alert: AlertTheme,
  Avatar: AvatarTheme,
  Button: ButtonTheme,
  Card: CardTheme,
  Checkbox: CheckboxTheme,
  Icon: IconTheme,
  Input: InputTheme,
  Menu: MenuTheme,
  Modal: ModalTheme,
  NumberInput: NumberInputTheme,
  Popover: PopoverTheme,
  Progress: ProgressTheme,
  Radio: RadioTheme,
  Switch: SwitchTheme,
  Table: TableTheme,
  Tabs: TabsTheme,
  Tag: TagTheme,
  Textarea: TextareaTheme,
};

export default components;
